function YoutubePopup() {
  document.querySelectorAll('.owd-youtube-popup-js').forEach((d) => d.addEventListener('click', playVideos));
  const body = document.body;
  function playVideos(e) {
    lvideo(e.currentTarget.dataset.url);

    body.classList.add('lvideo-active');
    body.style.overflow = "hidden"

    var lvideoWrap = document.createElement('DIV');
    lvideoWrap.setAttribute('id', 'lvideo-wrap');
    document.body.appendChild(lvideoWrap);


    const wrapper = document.getElementById('lvideo-wrap');
    wrapper.classList.add('active');

    const url = this.dataset.url;

    const startModal = `<span class="owd-modal:movie-overlay"></span><div class="owd-modal:movie-container"><div class="owd-modal:movie-container-content"><button class="owd-modal:movie-close lvideo-close"></button><div class="p-mt-common-content-iframe-scaler">`;
    const finishModal = `</div></div></div>`;

    const ytUrl = [url];

    var i,
      r,
      regExp = /^.*(?:(?:youtu\.be\/|v\/|vi\/|u\/\w\/|embed\/)|(?:(?:watch)?\?v(?:i)?=|\&v(?:i)?=))([^#\&\?]*).*/;

    for (i = 0; i < ytUrl.length; ++i) {
      r = ytUrl[i].match(regExp);
      document.getElementById(
        'lvideo-wrap'
      ).innerHTML = `${startModal}<iframe width="560" height="315" title="YouTube Video" src='https://www.youtube.com/embed/${r[1]}?rel=0&autoplay=1&0&loop=1&playlist=${r[1]}' frameborder="0" allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture' allowfullscreen></iframe>${finishModal}`;
    }
  }


  // LAUNCH
  function lvideo() {}
}

  // CLOSE MODAL LVIDEO
  function lvideoClose () {

    document.addEventListener('click', (e) => {
      if (e.target.matches('.owd-modal\\:movie-close') || e.target.matches('.owd-modal\\:movie-container')) {
        e.preventDefault();
        const body = document.body;
        body.classList.remove('lvideo-active');
        body.style.overflow = "auto"


        const wrapper = document.getElementById('lvideo-wrap');
        wrapper.parentNode.removeChild(wrapper);
      }
    })
  };

export { YoutubePopup,lvideoClose };
